import { faQuestionCircle } from '@fortawesome/pro-solid-svg-icons';
import { useTranslation } from 'react-i18next';

import { Button } from '../../shared/components/button/Button';

interface ChartEmptyStateProps {
  title: string;
  message?: string;
  width?: string;
  modalText?: string[];
  openModal?: (title: string, modalText: string[]) => void;
}

function ChartEmptyState({ title, message, width, modalText, openModal }: ChartEmptyStateProps) {
  const { t } = useTranslation();
  const displayMessage = message || t('chart.noDataAvailable');

  return (
    <div className={`chart-container ${width || ''}`}>
      <div className="title-container">
        <h3 className="title">{title}</h3>
        {openModal && modalText && (
          <Button
            variant="icon-only"
            className="wtf transparent-button"
            onClick={() => openModal(title, modalText)}
            ariaLabel={t('open.modal.chart.information')}
            icon={{ faIconDefinition: faQuestionCircle, className: 'wtf icon' }}
          />
        )}
      </div>
      <div className="charts-box chart-empty-state-box">
        <div className="chart-no-data chart-empty-state-label">{displayMessage}</div>
      </div>
    </div>
  );
}

export default ChartEmptyState;
